import apiClient from './apiClient';

const regionAPI = {
  getAllRegions: () => apiClient.get(`/get-regions?company_id=${localStorage.getItem('company_id')}`),
  
  getProvincies: () => {
    return apiClient.get(`/get-provincies?company_id=${localStorage.getItem('company_id')}`);
  },
  
  getCities: () => {
    return apiClient.get(`/get-cities?company_id=${localStorage.getItem('company_id')}`);
  }
};

export default regionAPI;